var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root-wrap"},[_c('van-button',{on:{"click":_vm.o}},[_vm._v("清除密码")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }